module.exports = __webpack_public_path__ + "static/hero-cta-1_2-d0d67011806e472e73f898e14e2a941e.png";